import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const LayoutSiderContext = getContext(Symbols.LayoutSiderContext, { getPrefixCls });
const BaseLayoutSiderContextProvider = function LayoutSiderContextProvider(props) {
    const { children, siderCollapsed, collapsedWidth, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        siderCollapsed,
        collapsedWidth,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, siderCollapsed, collapsedWidth]);
    return (React.createElement(LayoutSiderContext.Provider, { value: value }, children));
};
BaseLayoutSiderContextProvider.displayName = 'LayoutSiderContextProvider';
export const LayoutSiderContextProvider = memo(BaseLayoutSiderContextProvider);
export default LayoutSiderContext;
